import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { I18nProvider } from "@/lib/i18n";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Ticker } from "@/components/Ticker";
import { Services } from "@/components/Services";
import { Gallery } from "@/components/Gallery";
import { BookingForm } from "@/components/BookingForm";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";

const Home = () => (
  <main className="bg-[#0A0A0C] text-white min-h-screen">
    <Header />
    <Hero />
    <Ticker />
    <Services />
    <Gallery />
    <BookingForm />
    <Contact />
    <Footer />
    <WhatsAppFloat />
  </main>
);

function App() {
  return (
    <I18nProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="top-center"
          theme="dark"
          toastOptions={{
            style: {
              background: "#121215",
              border: "1px solid #27272A",
              color: "#fff",
              borderRadius: 0,
              fontFamily: "Barlow, sans-serif",
            },
          }}
        />
      </div>
    </I18nProvider>
  );
}

export default App;
